import { render } from "./MainBiodesainView.vue?vue&type=template&id=63114bd0&scoped=true"
import script from "./MainBiodesainView.vue?vue&type=script&lang=js"
export * from "./MainBiodesainView.vue?vue&type=script&lang=js"

import "./MainBiodesainView.vue?vue&type=style&index=0&id=63114bd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63114bd0"]])

export default __exports__